import api from '../lib/api';
import type { Ticket, TicketFormData, TicketFilters } from '../types/ticket';
import type { PaginatedResponse } from '../types/api';

export const ticketService = {
  list: async (
    page: number = 1,
    limit: number = 20,
    filters?: TicketFilters
  ): Promise<PaginatedResponse<Ticket>> => {
    const params: Record<string, string | number> = {
      page,
      limit,
    };

    if (filters?.status) {
      params.status = filters.status;
    }

    if (filters?.contact) {
      params.contact = filters.contact;
    }

    if (filters?.user_account_id != null) {
      params.user_account_id = filters.user_account_id;
    }

    if (filters?.queue_id) {
      params.queue_id = filters.queue_id;
    }

    if (filters?.start_date) {
      params.start_date = filters.start_date;
    }

    if (filters?.end_date) {
      params.end_date = filters.end_date;
    }

    if (filters?.ticket_id) {
      params.ticket_id = filters.ticket_id;
    }

    const response = await api.get<PaginatedResponse<Ticket>>('/messages/tickets', {
      params,
    });

    return response.data;
  },

  getById: async (id: number): Promise<Ticket> => {
    const response = await api.get<Ticket>(`/messages/tickets/${id}`);
    return response.data;
  },

  create: async (data: TicketFormData): Promise<Ticket> => {
    const response = await api.post<Ticket>('/messages/tickets', data);
    return response.data;
  },

  update: async (id: number, data: Partial<TicketFormData>): Promise<Ticket> => {
    const response = await api.put<Ticket>(`/messages/tickets/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/messages/tickets/${id}`);
  },
};
